import Cookies from "js-cookie";
import { ActiveUserProfile } from "@noom/hive-auth";

import { COOKIE_DOMAIN } from "@modules/common/constants";

// this is the client id which represents our end users
// logged in via web or native applications
const CLIENT_ID = "noom-coach";

const IDENTITY_COOKIE_KEY = "identity_data";

export type IdentityData = {
  email: string;
  accessCode: string;
  accessToken: string;
  clientId: string;
};

// by setting this cookie when the user logs in
// we allow the user to not need to log in again
// if we redirect them to buyflow or userportal
export const setIdentityCookieFromActiveUser = (user: ActiveUserProfile) => {
  Cookies.set(
    IDENTITY_COOKIE_KEY,
    JSON.stringify({
      email: user.email,
      accessCode: user.accessCode,
      accessToken: user.accessToken,
      clientId: CLIENT_ID,
    }),
    {
      // expires in 24 hours
      expires: new Date(Date.now() + 24 * 60 * 60 * 1000),
      domain: COOKIE_DOMAIN,
      path: "/",
      secure: true,
      sameSite: "strict",
    }
  );
};

export const removeIdentityCookie = () => {
  Cookies.remove(IDENTITY_COOKIE_KEY);
};
